import { render, staticRenderFns } from "./GenericReviewerList.vue?vue&type=template&id=0620aca1&scoped=true"
import script from "./GenericReviewerList.vue?vue&type=script&lang=js"
export * from "./GenericReviewerList.vue?vue&type=script&lang=js"
import style0 from "./GenericReviewerList.vue?vue&type=style&index=0&id=0620aca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620aca1",
  null
  
)

export default component.exports